import { IOLMNewJoinMembership } from '@ace-clublabs/common-membership-api-types';
import { IPartnerEnrollmentStatus } from './IPartnerEnrollmentStatus';

export interface IOLMNewJoinCacheData extends IOLMNewJoinMembership {
  id: string;
  applicantZipCode?: string;
  defaultCampaignCode?: string;
  promotion?: Promotion;
  paperlessOptOuts?: IPaperlessOptOut[];
  giftDetails?: GiftDetails;
  partnerEnrollmentStatuses?: IPartnerEnrollmentStatus[];
  paymentConfigVersion?: string;
  generateAutoLead?: boolean;
  trafficSourceCategory?: string;
  websiteSource?: string;
  trafficSource?: string;
  ins_quoteid?: string;
  testRegion?: string;
  rexId?: string;
}

export interface IOLMNewJoinCache {
  id: string;
  customerId?: string;
  membershipNumber?: string;
  stepName?: string;
  appName?: string;
  data?: string;
  pricing?: string | null;
  prospectiveMemberRules?: string | null;
}

export interface GiftDetails {
  startDate?: string; //captured
  endDate?: string; //captured
  isHoliday?: boolean; //static
  giftCardValue?: number; //static
  giftName?: string; //captured
  giftCardRecipient?: GiftMemberTypes; //captured
  membershipCardRecipient?: GiftMemberTypes; //captured
  //for ui rendering purpose only
  giftBillRecipientSelected?: boolean;
  messageCode?: string;
  donor?: Donor;
}

export enum GiftMemberTypes {
  RECIPIENT = 'RECIPIENT',
  DONOR = 'DONOR',
}

export type Address = {
  streetAddress?: string;
  unitType?: string;
  unitNumber?: string;
  city: string;
  state: string;
  zipCode: string;
  googleAddressId?: string;
};

export interface Donor {
  firstName?: string;
  lastName?: string;
  gender?: string;
  residenceAddress?: Address;
  mailingAddress?: Address;
  email?: string;
  mobileNumber?: string;
}

export enum Promotion {
  NA = 'N/A',
  BREAD_FINANCIAL_AAA_VISA = 'BREAD_FINANCIAL_AAA_VISA',
}

export enum PaperlessOptOutType {
  PHYSICAL_CARD = 'PHYSICAL_CARD',
  PAPERLESS_BILLING = 'PAPERLESS_BILLING',
  MAGAZINE = 'MAGAZINE',
}

export interface IPaperlessOptOut {
  type: PaperlessOptOutType;
  allowed: boolean;
  selected: boolean;
  label?: string;
}
